import type { SelectorObject } from '../types';

export const fixedChargesTabContentSelectors = {
  addFeeButton: 'fixed-charges-tab-content-add-fee-button',
} satisfies SelectorObject<'fixed-charges-tab-content-'>;